import React, { useEffect, useState } from 'react';

// @ts-ignore
import styles from './UnfinishedItem.module.scss';
import { joinClasses } from '../../../../../Utils/className.util';
import Text from '../../../../../Components/Base/Text/Text';
import Tag from '../../../../../Components/Tag/Tag';
import EHREntryInfo from '../../EHR/EHRExtract/EHREntry/EHREntryInfo';
import LinkButton from '../../../../../Components/Button/LinkButton';
import { Theme } from '../../../../../Enums/Theme.enum';
import FormattedDate from '../../../../../Components/FormattedDate';
import NZCIListItem from '../../Base/NZCIListItem';
import ElectronicDPNDetailModal from '../Detail/ElectronicDPNDetailModal';

interface Props {
  item: object
}

const WRAPPER_ID = 'unfinishedDPN';

const UnfinishedItem: React.FC<Props> = props => {
  const {item} = props;
  const [entryOpened, setEntryOpened] = useState<boolean>(false);

  return (
    <div className={styles.wrapper}>
      <div className={styles.border}>
        <div className={styles.content}>
          <div className={styles.header}>
            <div className={styles.openEntryName}>
              <Text tx={item.fullName} />
            </div>
          </div>
          <div className={styles.info}>
            <Text tx={'nczi.electronicDPN.list.from'} inline /> <strong><FormattedDate date={item.incapableFrom} /></strong>, <Text tx={'nczi.electronicDPN.detail.incapableDuration.anticipatedTerminationDate'} inline /> <strong><FormattedDate date={item.incapableDuration.anticipatedTerminationDate} /></strong>
          </div>
        </div>
        <div className={styles.controls}>
          <LinkButton
            title={'nczi.showDetails'}
            theme={Theme.BLUE}
            onClick={() => setEntryOpened(true)}
          />
        </div>
      </div>
      <ElectronicDPNDetailModal opened={entryOpened} onClose={() => setEntryOpened(false)} patientIdentifier={item.patientId} readonly={false} electronicConfirmation={{
        recordId: {
          code: item.recordId,
          scheme: {
            oid: '1.3.158.00165387.100.40.400'
          },
          valid: undefined
        },
        name: '',
        uncertaintyExpressed: false,
        archetypeId: 'CEN-EN13606-ENTRY.PotvrdenieDocasnejPraceneschopnosti.v1/at0000',
        items: [],
        info: undefined,
        structured: JSON.parse('[]')
      }} />
    </div>
  );
};

export default UnfinishedItem;
